import React, {useEffect, useState} from 'react';
import { SolutionModal } from '../../modals/solution/SolutionModal';
import { useTranslation } from 'react-i18next';
import './Square.css'
import { use } from 'i18next';

interface LeagueData {
    positions: string[];
    region: string[];
    releaseYears: number[];
    species: string[];
    gender: string[];
    range: string[];
    resource: string[];
}

interface ChampionData {
    champions: Champion[];
}

// Define a TypeScript interface for a Champion
interface Champion {
    id: number;
    name: string;
    positions: string[];
    region: string[];
    species: string[];
    releaseYear: string[];
    gender: string[];
    range: string[];
    resource: string[];
    src: string;
}

type RoleIcons = {
    mid: JSX.Element;
    top: JSX.Element;
    jungle: JSX.Element;
    support: JSX.Element;
    bot: JSX.Element;
};

export const Square = (props: any) => {
    const { i18n } = useTranslation();
    const [dataJSON, setDataJSON] = useState<LeagueData>();
    const [championsJSON, setChampionsJSON] = useState<ChampionData>();
    const [tracks, setTracks] = useState<string[]>()
    const [options, setOptions] = useState<string[]>()
    const [championsSolution, setChampionsSolution] = useState<Champion[]>()

    useEffect(() => {
        //DATA REGIONS POSITIONS ETC
        import(`../data-${i18n.language}.json`).then(data => {
          setDataJSON(data);
        }).catch(error => {
          console.error("Error cargando el archivo JSON data", error);
        });
    
        //DATA CHAMPIONS
        import(`../champs-${i18n.language}.json`).then(data => {
          setChampionsJSON(data);
        }).catch(error => {
          console.error("Error cargando el archivo JSON CHAMPIONS", error);
        });
        
      }, [i18n.language]);

    const roleIcons: RoleIcons = {
        mid: <svg className='svgPosition' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><g fill="none" fillRule="evenodd"><path className="roleBg" fill="#77779F" d="M7.786 2.651L10.437 0H0v10.437l2.651-2.651V2.65zM7.214 12.349L4.563 15H15V4.563l-2.651 2.651v5.135z"></path><path fill="#FFF" d="M12.536 0L0 12.536V15h2.464L15 2.465V0z"></path></g></svg>,
        top: <svg className='svgPosition' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><g fill="none" fillRule="evenodd"><path className="roleBg" fill="#77779F" d="M5.5 9.5h4v-4h-4z"></path><path className="roleBg" fill="#77779F" d="M15 15V1.172l-2.651 2.652v8.525H3.823L1.173 15z"></path><path fill="#FFF" d="M0 0v13.828l2.651-2.652V2.651h8.526L13.827 0z"></path></g></svg>,
        jungle: <svg className='svgPosition' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M2.886 0l.016.017C3.296.434 10.837 8.545 7.695 15c0 0-2.263-2.928-4.979-4.264 0 0 .453-3.955-2.716-6.575 0 0 4.3 1.85 5.206 4.726l.004-.017C5.275 8.582 6.1 4.6 2.886 0zM15 3.75s-3.225 2.877-2.66 6.421c0 0-2.263 1.336-2.659 2.158 0 0 .227-6.216 5.319-8.579zM11.82 0S9.33 4.315 9.555 7.5c0 0-.51.72-.68 1.336 0 0-.622-2.363-1.131-2.928 0 0 2.094-4.059 4.074-5.908z" fill="#FFF" fillRule="evenodd"></path></svg>,
        support: <svg className='svgPosition' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><path d="M7.902 5.316L9.5 13.393 7.5 15l-2-1.607 1.598-8.077.402.542.402-.542zM15 3.19c-.285 2.342-3.861 2.12-3.861 2.12l1.64 2.17-2.635 1.06L9 4.906l1.74-1.716zm-10.74 0L6 4.906 4.856 8.54 2.22 7.48l1.641-2.17S.285 5.532 0 3.19h4.26zM9.372 0L10 1.11 7.5 4.179 5 1.111 5.627 0h3.746z" fill="#FFF" fillRule="evenodd"></path></svg>,
        bot: <svg className='svgPosition' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><g fill="none" fillRule="evenodd"><path className="roleBg" fill="#77779F" d="M9.5 5.5h-4v4h4z"></path><path className="roleBg" fill="#77779F" d="M0 0v13.828l2.651-2.652V2.651h8.526L13.827 0z"></path><path fill="#FFF" d="M15 15V1.172l-2.651 2.652v8.525H3.823L1.173 15z"></path></g></svg>,
    };

    const {board, squareSelected, gameOver, squaresCorrects} = props;

    const [isSolutionModalOpen, setIsSolutionModalOpen] = useState(false);
    const handleSolutionModal = () => {
        setIsSolutionModalOpen(true);
        document.body.style.overflow = 'hidden';
        
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handleCloseSolutionModal = () => {
        setIsSolutionModalOpen(false);
        document.body.style.overflow = 'auto';
        document.body.style.overflowY = 'scroll';
    };

    const handleClick = () => {
        const row: string = "square"+squareSelected.charAt(6)+"0";
        const column: string = "square0"+squareSelected.charAt(7);
        const lastColumn: string = "square"+squareSelected.charAt(6)+"4";

        const rowElement = document.getElementById(row);
        const rowTrack = rowElement ? rowElement.getAttribute("data-value") : "";
    
        const columnElement = document.getElementById(column);
        const columnTrack = columnElement ? columnElement.getAttribute("data-value") : "";

        const lastColumnElement = document.getElementById(lastColumn);
        const lastColumnTrack = lastColumnElement ? lastColumnElement.getAttribute("data-value") : "";

        const tracksArray: Array<string> = [rowTrack, columnTrack, lastColumnTrack].filter(track => track !== null) as string[];

        setOptions(undefined)
        setChampionsSolution(undefined)
        let optionsArray: Array<string> = [];
        for (const track of tracksArray) {
            let option: keyof Champion;
            option = "positions"
            // Determine the key to check based on the criterion
            if(dataJSON)
            if (dataJSON.positions.includes(track)) {
              option = "positions";
            } else if (!isNaN(parseInt(track))) {
              option = "releaseYear";
            } else {
                if ( dataJSON.region.includes(track) ) {
                    option = "region";
                } else if (dataJSON.range.includes(track)) {
                    option = "range";
                } else if (dataJSON.gender.includes(track)) {
                    option = "gender";
                } else if (dataJSON.resource.includes(track)) {
                    option = "resource";
                } else {
                    option = "species"
                }
            }
            optionsArray.push(option)
            setOptions((prevOptions) => [...(prevOptions || []), option]);
        }
        
        if (tracksArray[0] !== "") {
            setTracks(tracksArray)
            handleSolutionModal();
            getSolutions(tracksArray, optionsArray);
        }
    }
      
    const checkChampionForTrack = (champ: Champion, track: string, optionsArray: string[]): boolean => {
        const validOptions: (keyof Champion)[] = ["positions", "releaseYear", "region", "species", "gender", "range", "resource"];
      
        for (const opt of optionsArray) {
          if (validOptions.includes(opt as keyof Champion)) {
            const champOption = champ[opt as keyof Champion];
      
            if (Array.isArray(champOption)) {
              if (champOption.includes(track)) {
                return true; // Coincide con la opción y la pista
              }
            } else if (typeof champOption === "string" && champOption === track) {
              return true; // Coincide con la opción y la pista
            }
          }
        }
        return false; // No coincide con ninguna opción o pista
    };
      
    const getSolutions = (tracksArray: string[], optionsArray: string[]) => {
        if(championsJSON)
        championsJSON.champions.forEach((champ) => {
            let countSolution: number = 0;
            tracksArray.forEach((track) => {
                if (checkChampionForTrack(champ, track, optionsArray)) {
                    countSolution = countSolution + 1;
                }
            })
            
            if (countSolution === 3) {
                setChampionsSolution((prevChampions) => {
                    const newChampions = [...(prevChampions || []), champ];
                    newChampions.sort((a, b) => a.name.localeCompare(b.name));
                    return newChampions;
                });
            }
        });
    };
      
      

    return (
        <div style={{width:"100%", position:"relative"}}>

            <SolutionModal 
                isOpen={isSolutionModalOpen} 
                onClose={handleCloseSolutionModal}
                tracks={tracks}
                options={options}
                championsSolution={championsSolution}
            />

            {board.map((row: string[], rowIndex: number) => (
                <div className='row' key={rowIndex}>
                {row.map((value, colIndex) => (
                    colIndex === 0 && rowIndex === 0 || colIndex === 4 && rowIndex === 0 ? (
                        <div className='squareInactive' key={rowIndex + colIndex}>
                            <img className={`clickGif ${colIndex === 4 ? "rotateImg" : ""}`} src={`${colIndex === 4 ? "karma.gif" : "ryze.gif"}`} alt="Gif LoLBoard" />
                        </div>
                    ) : (
                        <div
                            id={"square" + rowIndex + colIndex}
                            className= {`square ${props.clues && props.clues.includes("square" + rowIndex + colIndex) ? "clues" : ""} ${squaresCorrects.includes("square" + rowIndex + colIndex) ? "vibrate " : ""} ${value === "" ? "emptySquare " : ""} ${!gameOver && squareSelected === "square" + rowIndex + colIndex ?  "selected " : ""}${gameOver && squareSelected === "square" + rowIndex + colIndex ?  "selectedSolution " : ""}${gameOver && value === "" ? "loseSquare " : ""}`}
                            key={"square" +rowIndex + colIndex}
                            data-name="game"
                            data-value={colIndex === 4 || colIndex === 0 || rowIndex === 0 ? value : "squarePlay"}
                            onClick={gameOver && value === "" ? handleClick : undefined}
                        >
                        {colIndex === 0 || rowIndex === 0 ||colIndex === 4 ?                         
                            <span className={roleIcons[value as keyof RoleIcons] ? 'spanSquare' : "spanValue"}>
                                {roleIcons[value as keyof RoleIcons] || value.charAt(0).toUpperCase() + value.slice(1)}
                            </span> 
                            :
                            <span 
                                className="spanEmptySquare"                    
                                data-name="gameSquare"
                                data-value="gameSquare"
                                style={{ pointerEvents: 'none' }}
                            >
                                {!gameOver && squareSelected === "square" + rowIndex + colIndex ? "?" : ""}
                                {gameOver ?  <img className='clickImg' src="mano.png" alt="Click mano para ver soluciones"></img> : ""}
                            </span>
                        }
                    </div>
                    )
                ))}
                </div>
            ))}
        </div>
    )
}
